

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const PartnerOrderQuoteApi = createAsyncThunk("PartnerOrderQuote", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  // const response = await axiosInstance.get("/queryList",{ params });
  const response = await axiosInstance.get("/partner_order_qoute",{ params });
  return response.data;
});

const PartnerOrderQuoteSlice = createSlice({
  name: "PartnerOrderQuote",
  initialState: {
    PartnerOrderQuote: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(PartnerOrderQuoteApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(PartnerOrderQuoteApi.fulfilled, (state, action) => {
        state.PartnerOrderQuote = action.payload;
        state.loading = false;
      })
      .addCase(PartnerOrderQuoteApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default PartnerOrderQuoteSlice.reducer;
